export const color={
    background:'#000435',
    sidebar:'#000435',
    headingBackground:'#068dcc',
    white:"#fff",
    themeColor:"#068dcc",
    drawerFont:"#898791ff",
    bgSelect:'#b1b1b7ff',
    headerFont:"#068dcc"
}